<template>
    <el-dialog
        title="绑定巡演"
        :visible.sync="dialogVisible"
        center
        :close-on-click-modal="false"
        custom-class="custom-dialog">
        <div class="dialog-content">
            <el-form v-if="isBindList.length < 1" :model="formData" ref="formData">
                <el-form-item prop="name" label="巡演名称:" :rules="[{required: true, message: '请选择巡演'}]">
                    <el-autocomplete
                        v-model="formData.name"
                        :fetch-suggestions="searchTour"
                        placeholder="请输入巡演名称"
                        @select="selectTour"
                        :trigger-on-focus="false"
                        size="medium"
                        style="width:100%"
                        ref="searchInput"
                        >
                        <template slot-scope="{ item }">
                            <template v-if="noData">
                                没有找到相关数据
                            </template>
                            <div class="name" v-else>{{ item.name }}</div>
                        </template>
                    </el-autocomplete>
                </el-form-item>
            </el-form>
            <div v-else>
                <div>当前尝试绑定的巡演：{{formData.name}}</div>
                <div class="color-danger MT20">部分演出已经绑定有其他巡演，具体如下：如果继续，会自动解除与这些巡演的绑定关系</div>
                <el-table
                    :data="isBindList"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                >
                    <el-table-column prop="id" label="演出ID"></el-table-column>
                    <el-table-column prop="name" label="巡演" min-width="300"></el-table-column>
                </el-table>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button v-if="isBindList.length < 1" type="primary" :loading="btnLoading" @click="parseTour">确 定</el-button>
            <el-button v-else type="primary" :loading="btnLoading" @click="bindEvent">确认绑定</el-button>
        </span>
    </el-dialog>
</template>

<script>
const defaultFormData = {
    tourId:'',
    name:'',
    type:1
}
export default {
    props:{
        activityIds:{
            type:Array,
            default: () => []
        }
    },
    data(){
        return{
            dialogVisible: false,
            formData:{
                ...defaultFormData
            },
            tourList:[],
            searchLoading:false,
            btnLoading:false,
            tourItem:null,
            isBindList:[],
            noData: false,
            word:''
        }
    },
    methods:{
        show(){
            this.dialogVisible = true
        },
        close(){
            this.formData = { ...defaultFormData };
            this.$refs.formData && this.$refs.formData.resetFields();
            this.isBindList = [];
            this.tourItem = null;
            this.dialogVisible = false
        },
        //搜索巡演
        searchTour(query,cb){
            if(query != ""){
                this.word = query;
                this.searchLoading = true;
                this.noData = false;
                this.$request({
                    url: '/tour/manger/search',
                    method: 'POST',
                    params: {keywords:query}
                }).then(res => {
                    const { state, result } = res.data;
                    if( state == 1 ){
                        if(result && result.length > 0){
                            this.tourList = result;
                            cb(this.tourList);
                        }else{
                            this.tourList = [];
                            this.formData.tourId = '';
                            this.formData.name = query;
                            this.noData = true;
                            cb([this.noData]);
                        }
                    }
                }).catch( () => {
                    this.tourList = [];
                    this.formData.tourId = '';
                    this.formData.name = query;
                    this.noData = true;
                    cb([this.noData]);
                }).finally(() => {
                    this.searchLoading = false;
                });
            }
        },
        //选择巡演
        selectTour(e){
            if(this.noData){
                this.formData.name = this.word
            }else{
                this.formData.tourId = e.id;
                this.formData.name = e.name;
            }
        },
        //解析
        parseTour(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: '/activity/parseTour',
                        data: {...this.formData,activityIds:this.activityIds},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                               if( result.length > 0 ){
                                   this.isBindList = result;
                               }else{
                                   this.bindEvent();
                               }
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }else{
                    return false;
                }
            })    
        },
        //绑定巡演
        bindEvent(){
            this.btnLoading = true;

            this.$request({
                url: '/activity/saveTourTheme',
                data: {...this.formData,activityIds:this.activityIds},
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("绑定成功");
                        this.close();
                        this.$emit('onUpdate');
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>